import { Controller } from "@hotwired/stimulus"
import { isBackend, isElementInViewport } from '../../utils';
import '../../_jquery';

export default class extends Controller {
  static targets = ['report']
  focusInterval = null

  reportTitle() {
    return this.report.getAttribute('title')
  }

  connect() {
    this.initializePowerBiComponent()
    if (isBackend()) {
      this.element.classList.add('backend')
    } else {
      setTimeout(() => this.addEventListener(), 1200)

      this.focusInterval = setInterval(() => {
        window.focus()
      }, 500)
    }
  }

  disconnect() {
    if (this.lightbox) {
      this.timeOutReport = new Date().getTime()
      this.inReport = false
      this.handleTimeInReport()
    }
    clearInterval(this.focusInterval)
  }

  initializePowerBiComponent() {
    this.lightbox = this.element.closest('.lity')
    this.report = this.element.querySelector('iframe')
    this.inReport = false
    this.viewed = false
    this.timeInReport = 0
    this.timeOutReport = 0
    this.cmplz_blocker = null
    this.focusInterval = null

    if (this.lightbox) {
      this.handleViewed(true)
      this.inReport = true
      this.timeInReport = new Date().getTime()
    }
  }

  addEventListener() {
    if (!this.lightbox) {
      this.report.addEventListener('mouseover', () => {
        this.inReport = true;
        this.timeInReport = new Date().getTime()
        this.timeOutReport = 0
      })

      this.report.addEventListener('mouseout', () => {
        this.inReport = false;
        this.timeOutReport = new Date().getTime()
        this.handleTimeInReport()
      })
    }

    window.addEventListener('blur', () => {
      if (this.inReport) {
        this.handleEvent('powerbi-click', {'report' : this.reportTitle() })
      }
    })

    window.addEventListener('load', () => this.handleViewed())
    window.addEventListener('resize', () => this.handleViewed())
    window.addEventListener('scroll', () => this.handleViewed())

    if (this.lightbox) {
      this.cmplz_blocker = this.lightbox.querySelector('.cmplz-blocked-content-container')
    } else {
      this.cmplz_blocker = this.element.querySelector('.cmplz-blocked-content-container')
    }

    if (this.cmplz_blocker) {
      this.cmplz_blocker.addEventListener('click', () => {
        let interval = setInterval(() => {
          if (cmplz_has_consent('marketing')) {
            this.handleViewed(true)
            clearInterval(interval)
          }
        }, 1000)
      })
    }
  }

  handleViewed(force=false) {
    if (force || (isElementInViewport(this.report) && !this.viewed)) {
      this.handleEvent('powerbi-viewed', { 'report' : this.reportTitle() })
      this.viewed = true
    }
  }

  handleTimeInReport() {
    let timeInReport = (this.timeOutReport - this.timeInReport) / 1000
    if (timeInReport < 1.5) { return }

    this.handleEvent('powerbi-time-in', { 'report': this.reportTitle(), 'time_in_report': timeInReport })
  }

  handleEvent(kind, data = {}) {
    if (isBackend()) { return }
    if (!cmplz_has_consent('marketing')) { return }

    console.log('PowerBi Event', kind, data)
    dataLayer.push(Object.assign({}, { 'event': kind }, data));
  }
}
